"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Commands that are sent to a shared session in a webworker
 */
var WorkerCommand;
(function (WorkerCommand) {
    WorkerCommand["CONNECT"] = "connect";
    WorkerCommand["CONNECT_EXISTING"] = "connect-existing";
    WorkerCommand["CLOSE"] = "close";
    WorkerCommand["MESSAGE"] = "message";
    WorkerCommand["STREAM"] = "stream";
    WorkerCommand["SERVICE"] = "service";
    WorkerCommand["LOCK"] = "lock";
    WorkerCommand["CID"] = "cid";
})(WorkerCommand = exports.WorkerCommand || (exports.WorkerCommand = {}));
/**
 * Webworker commands to manage a session lock
 */
var WorkerSessionLockCommand;
(function (WorkerSessionLockCommand) {
    WorkerSessionLockCommand["ACQUIRED"] = "acquired";
    WorkerSessionLockCommand["ACQUIRE_ERROR"] = "acquire_error";
    WorkerSessionLockCommand["OWNED"] = "owned";
    WorkerSessionLockCommand["REMOVED"] = "removed";
    WorkerSessionLockCommand["RELEASED"] = "released";
    WorkerSessionLockCommand["RELEASE_ERROR"] = "release_error";
})(WorkerSessionLockCommand = exports.WorkerSessionLockCommand || (exports.WorkerSessionLockCommand = {}));
/**
 * Webworker commands relating to stream events
 */
var WorkerStreamCommand;
(function (WorkerStreamCommand) {
    WorkerStreamCommand["OPEN"] = "open";
    WorkerStreamCommand["VALUE"] = "value";
    WorkerStreamCommand["SUBSCRIPTION"] = "subscription";
    WorkerStreamCommand["UNSUBSCRIPTION"] = "unsubscription";
    WorkerStreamCommand["SUBSCRIPTION_ERROR"] = "subscription_error";
})(WorkerStreamCommand = exports.WorkerStreamCommand || (exports.WorkerStreamCommand = {}));



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/webworker/worker-command.js
// module id = 289
// module chunks = 0